import { type SimulatorInputs, type SimulatorValues, VEHICLE_PRESETS, type VehiclePreset } from 'used-vehicle-engine';

/** Applies a quick-fill preset over the current entries: the vehicle changes, the condition stays. */
export const applyPreset = (inputs: SimulatorInputs, preset: VehiclePreset): SimulatorInputs => ({
  ...inputs,
  preset: preset.key,
  brand: preset.brand,
  model: preset.model,
  price: preset.price,
  cat: preset.cat,
  equity: preset.equity,
  trim: preset.trim,
  fuel: preset.fuel,
  table: preset.table,
});

/** What the page opens with: the Corolla preset, three years old with 90,000 km and a 4 جيد inspection. */
export const initialInputs = (): SimulatorInputs =>
  applyPreset(
    {
      preset: null,
      brand: '',
      model: '',
      equity: 'vhigh',
      cat: 'low',
      agency: 'excellent',
      price: 0,
      fuel: 'petrol',
      trim: 'high',
      demand: 'normal',
      supply: 'normal',
      age: 3,
      odometer: 90_000,
      owners: 2,
      usage: 'private',
      specs: 'local',
      warranty: false,
      facelift: false,
      customs: false,
      grade: 'G4',
      sev: { interior: 'MINOR', body: 'EXCELLENT', engine: 'EXCELLENT', hybrid: 'EXCELLENT', tires: 'MODERATE' },
      dmg1: 0,
      dmg2: 1,
      service: 'full',
      table: 'standard',
    },
    VEHICLE_PRESETS[0]!,
  );

/** Writes `value` at a dotted `path` (`usage.2.pct`, `grade.standard.G2`) of a copy of `values`. */
export const withValueAt = (values: SimulatorValues, path: string, value: number | string): SimulatorValues => {
  const next = JSON.parse(JSON.stringify(values)) as SimulatorValues;
  const keys = path.split('.');
  let target: Record<string, unknown> = next as unknown as Record<string, unknown>;

  for (const key of keys.slice(0, -1)) {
    const child = target[key];

    if (typeof child !== 'object' || child === null) {
      return values;
    }

    target = child as Record<string, unknown>;
  }

  target[keys[keys.length - 1]!] = value;

  return next;
};
